import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lines",
  "use": "lines-usage",
  "viewBox": "0 0 21 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 26\" id=\"lines\"><path fill-rule=\"evenodd\" d=\"M3.899 25.347a.92.92 0 0 0 .456-1.217l-2.52-5.537a.919.919 0 0 0-1.671.761l2.519 5.537a.92.92 0 0 0 1.216.456m16.555-6.317a.92.92 0 0 0-.336-1.255L10.32 12.12a.919.919 0 0 0-.918 1.59l9.798 5.657a.92.92 0 0 0 1.255-.336zm-1.62-17.043a.92.92 0 0 0-.862-.972L11.658.636a.919.919 0 0 0-.11 1.834l6.314.379a.92.92 0 0 0 .972-.862\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol